export default __webpack_public_path__ + "static/Loadout_Mannequin-105c081dc3f89c35d20829340d7a7d03.png";